import React, { Component } from "react";

import { colors, Icon } from "assets";

export default class ImportStockCount extends Component {
  render() {
    const borderStyle = {
      borderWidth: 2,
      borderColor: "#16303d",
      borderStyle: "dashed",
      borderRadius: 5,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      padding: "0px 12px",
      height: 200,
      opacity: 0.6
    };

    const textStyle = {
      fontWeight: 350,
      fontSize: 22
    };

    const iconStyle = {
      opacity: 1,
      padding: 0,
      height: 44,
      width: 44,
      color: colors.secondary.dark
    };

    return (
      <div>
        <div style={{ ...borderStyle }}>
          <Icon.CsvFile style={{ ...iconStyle }} />
          <span style={{ ...textStyle }}>
            Abra a planilha baixada anteriormente no seu editor e faça a
            contagem.
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/adjust/import-stock-count/edit-step/index.js